export * from './alert.component';
export * from './alert.service';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/alert/index.ts